import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { VendorHeaderTemplateRawDto } from './vendor-header-template-raw-dto';
import { VendorLineItemCodingTemplateRawDto } from './vendor-line-item-coding-template-raw-dto';
const ɵ0 = () => VendorHeaderTemplateRawDto, ɵ1 = () => VendorLineItemCodingTemplateRawDto;
export class WFVendorCodingDefaultTemplateParametersDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", VendorHeaderTemplateRawDto)
], WFVendorCodingDefaultTemplateParametersDto.prototype, "headerTemplate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], WFVendorCodingDefaultTemplateParametersDto.prototype, "lineItemTemplates", void 0);
export { ɵ0, ɵ1 };
